import { Badge, Popconfirm, Tooltip } from "antd";
import { useMemo } from "react";
import { Link } from "react-router-dom";
import {
  DocumentationWarningIcon,
  GoBack,
  HeaderUser,
  IconDetyrat,
  IconDil,
  IconNojftimet,
  LogoFlex,
  IntervistatIcon,
  ChartIcon,
  ContactsIcon,
} from "../../../assets/icons";
import HamburgerMenu from "../../../utils/MobileComponents/HamburgerMenu";
import DynamicHeaderTitle from "../DynamicHeaderTitle";
import { useAuth } from "../../../authentication/authHelpers";
import { useSelector } from "react-redux";
import ThemeToggle from "./ThemeToggle";

function MobileHeader({
  location,
  handleLogOut,
  setRequestsActive,
  requestsActive,
  pendingRequest,
  setNotifsActive,
  setOpenStats,
  notifsActive,
  count,
  setOpenContactsModal,
  userPhoto,
  problemsActive,
  setProblemsActive,
  problematikatCount,
  setInterviewActive,
  interviewActive,
  candidatesCount,
}) {
  const auth = useAuth();
  const { isDarkMode } = useSelector((state) => state.usersList);

  const [isConfig, isKryefaqja] = useMemo(() => {
    return [
      location.pathname.startsWith("/konfigurimet"),
      location.pathname.startsWith("/kryefaqja"),
    ];
  }, [location.pathname]);

  const renderPfp = useMemo(
    () =>
      userPhoto?.length > 0 && userPhoto !== null ? (
        <img
          src={userPhoto}
          alt="Flex"
          width={32}
          height={32}
          style={{ borderRadius: 5 }}
        />
      ) : (
        <HeaderUser />
      ),
    [userPhoto]
  );

  const isAdmin =
    auth?.user?.userRole === "Admin" || auth?.user?.userRole === "Super Admin";

  return (
    <div
      className={`header-app ${isDarkMode ? "dark" : ""}`}
      style={{
        width: "100%",
        ...(isDarkMode ? {} : { background: isConfig ? "#b31312" : "#1d3445" }),
      }}
    >
      <HamburgerMenu data={auth} />
      {isConfig ? <DynamicHeaderTitle /> : null}

      <div className="icons">
        {isKryefaqja ? (
          <>
            <Link to="/konfigurimet/kompania/profili">{renderPfp}</Link>
            <ThemeToggle />
          </>
        ) : null}

        <div onClick={() => setOpenContactsModal(true)}>
          <ContactsIcon fill="#fbfbfb" />
        </div>

        {isConfig ? (
          <Link to="/kryefaqja" style={{ margin: 0, padding: 0 }}>
            <GoBack fill="#fff" />
          </Link>
        ) : null}

        {!isKryefaqja && !isConfig ? (
          <>
            <Link to="/konfigurimet/kompania/profili">{renderPfp}</Link>
            <ThemeToggle />
            <Link to="/kryefaqja" style={{ margin: 0, padding: 0 }}>
              <GoBack fill="#fff" />
            </Link>
          </>
        ) : null}
        {!isConfig ? (
          <>
            {isAdmin ? (
              <div onClick={() => setRequestsActive(!requestsActive)}>
                <Badge
                  className="notification-badge"
                  count={pendingRequest?.length}
                >
                  <IconDetyrat />
                </Badge>
              </div>
            ) : null}{" "}
            {isAdmin ? (
              <div onClick={() => setOpenStats((prev) => !prev)}>
                <Tooltip placement="bottom" title="Grafiku organizativ">
                  <ChartIcon />
                </Tooltip>
              </div>
            ) : null}
            {auth?.user?.userRole === "Admin" ||
            auth?.user?.userRole === "Super Admin" ? (
              <div onClick={() => setInterviewActive(!interviewActive)}>
                <Badge className="notification-badge" count={candidatesCount}>
                  <IntervistatIcon fill="white" />
                </Badge>
              </div>
            ) : null}
            {isAdmin ? (
              <div onClick={() => setProblemsActive(!problemsActive)}>
                <Badge
                  className="notification-badge"
                  count={problematikatCount}
                >
                  <DocumentationWarningIcon fill={"white"} />
                </Badge>
              </div>
            ) : null}
            <div onClick={() => setNotifsActive(!notifsActive)}>
              <Badge className="notification-badge" count={count?.length}>
                <IconNojftimet />
              </Badge>
            </div>
          </>
        ) : null}

        <Popconfirm
          placement="bottom"
          title={"A jeni të sigurt që dëshironi të dilni nga programi?"}
          onConfirm={handleLogOut}
          okText="Po"
          cancelText="Jo"
          classNames={{
            root: `popup-logout-modal globalPopover ${
              isDarkMode ? "dark" : ""
            }`,
          }}
          icon={<LogoFlex width={45} height={45} />}
        >
          <IconDil />
        </Popconfirm>
      </div>
    </div>
  );
}

export default MobileHeader;
